import React from "react";
//import { createMuiTheme, makeStyles, ThemeProvider } from '@material-ui/core/styles';
import Grid from "@material-ui/core/Grid";
import DateFnsUtils from "@date-io/date-fns";
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from "@material-ui/pickers";

//const theme = createMuiTheme({
//    overrides: {
//        MuiPickersToolbar: {
//            root: {
//                backgroundColor: "#000028"
//            }
//        }
//    }
//});

function FormDatePicker(props) {
   //const [dateOfBirth, handleChangeDOB] = useState(new Date());
   // const [selectedDate, handleDateChange] = useState(new Date());
   // const handleDateChange = (date) => {
   //   setSelectedDate(date);
   //};
    function dateChangeEvent(date) {
        props.onChange(date, props.label);
    }
    //const dateChangeEvent = date => {
    //    const inputDate = date.format();
    //    props.dateChangeEvent(inputDate);
    //}

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils} variant={"filled"}>
            <Grid container className='' justify="space-around">
                <KeyboardDatePicker
                    fullWidth
                    clearable
                    label={props.label}
                    value={props.value}
                    onChange={dateChangeEvent}
                    format="dd/MM/yyyy"
                    disableFuture={props.disablefuturedate}
                    required={props.required}
                    InputLabelProps={{
                        shrink: true,
                    }}                   
                />
            </Grid>
        </MuiPickersUtilsProvider>
    );
}

export default FormDatePicker;